import axios from '@/utils/axios'

const getActionType = (query, config) => axios.get('/api/v1/pc/actionType/list', query, config)

const getActionGoods = (goodsActionTypeId, query, config) => axios.get(`/api/v1/pc/action/list/${goodsActionTypeId}`, query, config)

export default {
  getActionType,
  getActionGoods,
}


// WEBPACK FOOTER //
// ./src/api/modules/promotion.js